import React, { useCallback, useState } from 'react';
import {  Copy, Check, Radiation, Database, Trash2, Trophy, Blocks, Rocket, Zap, Crown, History, Github, Cpu, Brain } from 'lucide-react'; 


const RaidlyLanding = () => {
const playSound1 = useCallback(() => {
      const audio = new Audio('/SWMG2.mp3');
      audio.volume = 0.5;
      audio.play().catch(error => {
        console.error('Error playing audio:', error);
      });
    }, []);

  const playSound2 = useCallback(() => {
    const audio = new Audio('/nuke.mp3');
    audio.volume = 0.5;
    audio.play().catch(error => {
      console.error('Error playing audio:', error);
    });
  }, []);

  const playSound3 = useCallback(() => {
    const audio = new Audio('/SHADOWCURSED.mp3');
    audio.volume = 0.5;
    audio.play().catch(error => {
      console.error('Error playing audio:', error);
    });
  }, []);

  const [copied, setCopied] = useState(false);
  const fullTag = "1Lxt6zCQ7jzkawfSYdKcru3NWVizJwXup5Sz3fMpump";
  
  // Create masked version of the text
  const createMaskedText = (text) => {
    if (text.length <= 8) return text;
    return `${text.slice(0, 6)}...${text.slice(-6)}`;
  };
  
  const maskedTag = createMaskedText(fullTag);

  const handleCopy = async () => {
    try {
      // Copy the full tag, not the masked version
      await navigator.clipboard.writeText(fullTag);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const MarqueeRow = ({ children, direction = 'left', speed = 'normal' }) => {
    const getAnimationClass = () => {
      const baseAnimation = direction === 'right' ? 'animate-marquee-reverse' : 'animate-marquee';
      switch (speed) {
        case 'fast':
          return 'animate-marquee-fast';
        case 'slow':
          return 'animate-marquee-slow';
        default:
          return baseAnimation;
      }
    };
  
    // Create multiple duplicates to ensure smooth looping
    const duplicates = Array(4).fill(children);
  
    return (
      <div className="w-full overflow-hidden bg-transparent relative">
        {/* Add a gradient mask at the edges */}
        <div className="absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-zinc-950 to-transparent z-10" />
        <div className="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-zinc-950 to-transparent z-10" />
        
        {/* Main scrolling content */}
        <div className={`flex ${getAnimationClass()}`}>
          {duplicates.map((duplicate, index) => (
            <div key={index} className="flex gap-6 shrink-0 pr-6">
              {duplicate}
            </div>
          ))}
        </div>
      </div>
    );
  };

  const ImageCard = ({ name, image, imageScaling = "contain", link }) => {
    const getImageStyle = (scaling) => {
      if (typeof scaling === 'number') {
        return {
          transform: `scale(${scaling})`,
          objectFit: 'contain'
        };
      }
      return {
        objectFit: scaling
      };
    };
  
    const CardContent = () => (
      <div className="group relative">
        <div className="absolute inset-0 bg-gradient-to-r from-red-500/5 to-rose-500/5 rounded-lg blur-lg group-hover:blur-xl transition-all"/>
        <div className="relative p-4 backdrop-blur-sm bg-black/40 rounded-lg border border-red-500/10 hover:border-red-500/20 transition-all">
          <div className="flex justify-center items-center mb-3">
            <div className="w-24 h-24 relative overflow-hidden">
              <img 
                src={image} 
                alt={name}
                className="w-full h-full"
                style={getImageStyle(imageScaling)}
              />
            </div>
          </div>
          <p className="text-center text-gray-400 font-medium">
            {name}
          </p>
        </div>
      </div>
    );
  
    if (link) {
      return (
        <a 
          href={link} 
          target="_blank" 
          rel="noopener noreferrer"
          className="block cursor-pointer"
        >
          <CardContent />
        </a>
      );
    }
  
    return <CardContent />;
  };
  
    

  const LinkButton = ({ children, className }) => {
    return (
      <a 
        href="https://x.com/intent/post?text=%40ChainFud+what+do+you+think+of+%3Cinsert+ticker+or+CA%3E"
        target="_blank"
        rel="noopener noreferrer"
        className={`${className} cursor-pointer`}
        onClick={playSound1}
      >
        {children}
      </a>
    );
  };

  const GithubButton = ({ children, className }) => {
    return (
      <a 
        href="https://github.com/invntiv/ChainFudAgent"
        target="_blank"
        rel="noopener noreferrer"
        className={`${className} cursor-pointer`}
        onClick={playSound3}
      >
        {children}
      </a>
    );
  };

  const HistoryButton = ({ children, className }) => {
    return (
      <a 
        href="https://x.com/ChainFud"
        target="_blank"
        rel="noopener noreferrer"
        className={`${className} cursor-pointer`}
        onClick={playSound2}
      >
        {children}
      </a>
    );
  };

  const milestones = [
    {
      phase: "Phase 1",
      title: "Launch",
      status: "Completed",
      description: "Initial release of ChainFud with core fudding capabilities",
      icon: Rocket,
      items: [
        "Auto-fudding system deployment",
        "Twitter integration",
        "Basic AI training"
      ]
    },
    {
      phase: "Phase 2",
      title: "Growth",
      status: "In Progress",
      description: "Expanding ChainFud's capabilities and reach",
      icon: Zap,
      items: [
        "Telegram integration (in development)",
        "Paid features for holders",
        "Advanced sentiment analysis",
        "Python/JS support",
        "Multi-chain support",
      ]
    },
    {
      phase: "Phase 3",
      title: "Domination",
      status: "Upcoming",
      description: "Becoming the ultimate FUD machine",
      icon: Crown,
      items: [
        "Bot swarms",
        "Anonymous ChainFud clones",
        "Instagram, TikTok integration"
      ]
    }
  ];

  const technologies = [
    {
      category: "Core Stack",
      icon: Cpu,
      items: [
        { name: "Rust", image: "/rust.png", link: "https://www.rust-lang.org/" },
        { name: "Rig", image: "/rig-dark.svg", link: "https://github.com/0xPlaygrounds/rig" },
        { name: "Tokio", image: "/tokio.svg", link: "https://tokio.rs/" },
      ]
    },
    {
      category: "Infrastructure",
      icon: Database,
      items: [
        { name: "SolanaTracker", image: "/solanatracker.PNG", link: "https://solanatracker.io/" },
        { name: "HeliusRPC", image: "/helius.png", link: "https://helius.xyz/" },
        { name: "X API", image: "/x.jpg", link: "https://developer.twitter.com/" }
      ]
    },
    {
      category: "Supported Models",
      icon: Brain,
      items: [
        { name: "Claude", image: "/claude.png", link: "https://docs.rs/rig-core/latest/rig/providers/index.html?search=anthropic" },
        { name: "GPT", image: "/gpt.png", link: "https://docs.rs/rig-core/latest/rig/providers/index.html?search=gpt" },
        { name: "Grok", image: "/grok.png", link: "https://docs.rs/rig-core/latest/rig/providers/xai/index.html" },
        { name: "Gemini", image: "/gemini.png", link: "https://docs.rs/rig-core/latest/rig/providers/xai/index.html?search=gemini" },
        { name: "Perplexity", image: "/perplexity.png", link: "https://docs.rs/rig-core/latest/rig/providers/perplexity/index.html" },
      ]
    },
  ];

  return (
    <div className="min-h-screen bg-zinc-950 text-gray-100">
      <div className="fixed inset-0" style={{
        backgroundImage: `
          linear-gradient(90deg, rgba(255, 0, 0, 0.03) 1px, transparent 1px),
          linear-gradient(180deg, rgba(255, 0, 0, 0.03) 1px, transparent 1px)
        `,
        backgroundSize: '40px 40px'
      }}/>

      <div className="relative">
      <header className="border-b border-red-500/10 backdrop-blur-sm bg-black/40">
        <nav className="container mx-auto px-6 py-4">
          {/* Main nav container - stack on mobile, row on desktop */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            {/* Logo section - always left aligned */}
            <div className="flex items-center space-x-3">
              <div className="relative">
                <div className="absolute inset-0 bg-red-500 blur-md opacity-20"/>
                <Radiation className="w-8 h-8 text-red-500 relative"/>
              </div>
              <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-red-500 to-rose-500">
                ChainFud
              </span>
            </div>

            {/* Buttons container - full width on mobile, right aligned on desktop */}
            <div className="flex flex-col md:flex-row items-stretch md:items-center space-y-2 md:space-y-0 md:space-x-4">
              
              <GithubButton className="group inline-flex px-8 py-2 bg-gradient-to-r from-slate-500 to-slate-600 rounded-lg relative overflow-hidden hover:from-slate-600 hover:to-slate-700 transition-colors">
                <span className="relative flex items-center justify-center space-x-2">
                  <Github className="w-5 h-5" />
                  <span>View on Github</span>
                </span>
              </GithubButton>
              
              <LinkButton className="group inline-flex px-8 py-2 bg-gradient-to-r from-red-500 to-rose-600 rounded-lg relative overflow-hidden hover:from-red-600 hover:to-rose-700 transition-colors">
                <span className="relative flex items-center justify-center space-x-2">
                  <Radiation className="w-5 h-5" />
                  <span>Try ChainFud now</span>
                </span>
              </LinkButton>
            </div>
          </div>
        </nav>
      </header>

        <div className="container mx-auto px-6 pt-12 pb-12">
      <div className="max-w-2xl mx-auto text-center">
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-red-500 to-rose-500 rounded-full blur opacity-30"></div>
            <div className="relative w-36 h-36 rounded-full overflow-hidden border-2 border-red-500/20">
              <img
                src="/profile.PNG"
                alt="Profile"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
        <div className="inline-block mb-6">
          <div className="px-4 py-2 border border-red-500/20 rounded-full text-sm text-red-400 bg-red-800/5 backdrop-blur-sm">
            Solana's First Auto-fudding AI Agent
          </div>
          
        </div>
        <h1 className="text-4xl font-bold mb-8 bg-clip-text text-transparent bg-gradient-to-r from-red-800 via-rose-500 to-yellow-500">
          FUCK THE COMPETITION <span className="italic text-5xl">#DontDoRugsKids</span>
        </h1>
            <div 
              onClick={handleCopy}
              className="inline-flex items-center space-x-2 px-4 py-2 bg-white/70 hover:bg-white/40 
                        border border-red-500/20 rounded-lg cursor-pointer transition-all duration-200 mb-4"
            >
              <span className="text-black font-mono">{maskedTag}</span>
              <div className="w-5 h-5 text-black">
                {copied ? <Check className="w-full h-full" /> : <Copy className="w-full h-full" />}
              </div>
            </div>
        
        <p className="text-2xl text-gray-400 mb-12 ml-12 text-left">
          ☢️ Open source Rust framework! <br/>
          ☢️ FUDs a random trending token every 15min! <br/>
          ☢️ Replies to selected mentions every 5min! <br/>
          ☢️ FUD your enemies' bags - or do it for fun! <br/>
          ☢️ Replaces 10,000 Indians!<br/>
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <LinkButton 
            className="group inline-flex px-8 py-3 bg-gradient-to-r from-red-500 to-rose-600 rounded-lg relative overflow-hidden hover:from-red-600 hover:to-rose-700 transition-colors">
              <span className="relative flex items-center justify-center space-x-2">
                <Radiation className="w-5 h-5" />
                <span>Try ChainFud now</span>
              </span>
          </LinkButton>
          <HistoryButton className="group inline-flex px-8 py-3 bg-gradient-to-r from-orange-500 to-yellow-600 rounded-lg relative overflow-hidden hover:from-orange-600 hover:to-yellow-700 transition-colors">
            <span className="relative flex items-center justify-center space-x-2">
              <History className="w-5 h-5" />
              <span>View FUD History</span>
            </span>
          </HistoryButton>
        </div>
        
      </div>
    </div>

    <div className="container mx-auto px-6 py-10">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 h-full">
        {[
          { icon: Database, title: "Token Data", desc: "Utilizes SolanaTracker API to get instantaneous token data for maximum efficacy." },
          { icon: Trophy, title: "Trending Tokens", desc: "Asseses trending tokens every 15 minutes and randomly fuds one. Get the entry you always wanted!" },
          { icon: Trash2, title: "Heavyweight Insults", desc: "Trained and curated to talk mad shit and circumvent AI guardrails." },
          { icon: Blocks, title: "Extensible & Open Source", desc: "Completely open source and extensible; enhance ChainFud or customize for any AI Agent application." },
        ].map((feature, i) => (
          <div key={i} className="group relative h-full">
            <div className="absolute inset-0 bg-gradient-to-r from-red-500/5 to-rose-500/5 rounded-xl blur-lg group-hover:blur-xl transition-all"/>
            <div className="relative h-full p-8 backdrop-blur-sm bg-black/40 rounded-xl border border-red-500/10 hover:border-red-500/20 transition-all">
              <div className="flex items-center space-x-4 mb-4">
                <feature.icon className="w-6 h-6 text-red-500" />
                <h3 className="text-xl font-semibold">{feature.title}</h3>
              </div>
              <p className="text-gray-400">{feature.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>

  {/* ABOUT SECTION*/}
  <div className="container mx-auto px-6 py-20 border-t border-red-500/10">
      <h2 className="text-4xl font-bold text-center mb-16 bg-clip-text text-transparent bg-gradient-to-r from-red-500 to-rose-500">
        About
      </h2>

      <div className="max-w-6xl mx-auto">
        {/* Main description card */}
        <div className="relative mb-16">
          <div className="absolute inset-0 bg-gradient-to-r from-red-500/5 to-rose-500/5 rounded-xl blur-lg"/>
          <div className="relative p-8 backdrop-blur-sm bg-black/40 rounded-xl border border-red-500/10">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-2xl font-semibold mb-4 text-red-400">Built for Maximum Chaos</h3>
                <p className="text-gray-400 mb-4">
                  ChainFud is fully open-source.<br/><br/>
                  Powered by advanced AI models and blockchain data feeds, it's designed to create the 
                  perfect storm of FUD - however it can be extended and customized to suit whatever purpose you see fit!
                </p>
                <div className="flex items-center space-x-4">
                  <GithubButton className="group inline-flex px-8 py-2 bg-gradient-to-r from-slate-500 to-slate-600 rounded-lg relative overflow-hidden hover:from-slate-600 hover:to-slate-700 transition-colors">
                    <span className="relative flex items-center justify-center space-x-2">
                      <Github className="w-5 h-5" />
                      <span>View on Github</span>
                    </span>
                </GithubButton>                
              </div>
              </div>
              <div className="flex justify-center items-center mt-4">
                <div className="w-full max-w-md">
                   <a 
                    href="https://github.com/invntiv/ChainFudAgent" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors"
                  >
                    <img 
                    src="https://ghc.clait.sh/repo/invntiv/ChainFudAgent?bg_color=ffffff&title_color=0366d6&text_color=333333&icon_color=333333&show_user=true" 
                    alt="GitHub Repo Card"
                    className="w-full rounded-lg"
                  />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {technologies.map((tech, index) => (
          <div key={index} className="mb-12">
            <div className="flex items-center space-x-3 mb-6">
              <tech.icon className="w-6 h-6 text-red-500"/>
              <h3 className="text-xl font-semibold text-gray-100">{tech.category}</h3>
            </div>
            
            <MarqueeRow 
              direction={index % 2 === 0 ? 'left' : 'right'} 
              speed={['normal', 'slow', 'fast'][index % 3]}
            >
              {tech.items.map((item, itemIndex) => (
                <ImageCard 
                  key={itemIndex}
                  name={item.name}
                  image={item.image}
                  imageScaling="contain"
                  link={item.link}
                />
              ))}
            </MarqueeRow>
          </div>
        ))}
      </div>
    </div>

    <div className="container mx-auto px-6 py-20 border-t border-red-500/10">
      <h2 className="text-4xl font-bold text-center mb-16 bg-clip-text text-transparent bg-gradient-to-r from-red-500 to-rose-500">
        Roadmap
      </h2>
      
      <div className="relative max-w-4xl mx-auto">
        {/* Timeline line - hidden on mobile, shown on md+ */}
        <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-px bg-red-500/20" />
        
        {milestones.map((milestone, index) => (
          <div key={index} className={`relative mb-16 flex flex-col md:flex-row ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`}>
            {/* Content */}
            <div className="w-full md:w-1/2 px-4 md:px-8">
              <div className="backdrop-blur-sm bg-black/40 rounded-xl p-6 border border-red-500/10 hover:border-red-500/20 transition-all">
                {/* Phase indicator - mobile only */}
                <div className="flex md:hidden items-center space-x-2 mb-3">
                  <div className="w-2 h-2 rounded-full bg-red-500" />
                  <span className="text-sm text-red-400">{milestone.phase}</span>
                </div>
                
                <div className="flex items-center space-x-3 mb-4">
                  <milestone.icon className="w-6 h-6 text-red-500" />
                  <h3 className="text-xl font-semibold text-gray-100">{milestone.title}</h3>
                </div>
                
                <div className={`inline-block px-3 py-1 rounded-full text-sm mb-3 ${
                  milestone.status === 'Completed' ? 'bg-green-500/10 text-green-400' :
                  milestone.status === 'In Progress' ? 'bg-blue-500/10 text-blue-400' :
                  'bg-gray-500/10 text-gray-400'
                }`}>
                  {milestone.status}
                </div>
                
                <p className="text-gray-400 mb-4">{milestone.description}</p>
                
                <ul className="space-y-2">
                  {milestone.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-center space-x-2 text-gray-400">
                      <Check className="w-4 h-4 text-red-500 flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            {/* Timeline dot - hidden on mobile, shown on md+ */}
            <div className="hidden md:block absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <div className="w-4 h-4 rounded-full bg-red-500 z-10">
                <div className="absolute inset-0 rounded-full bg-red-500 animate-ping opacity-20" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>
  </div>
  );
};

export default RaidlyLanding;